import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Section } from '../../styled-components';

/* Línea superior */
const TopLine = styled.div`
  width: 100%;
  height: 1px;
  background: #cfcfcf;
  margin-bottom: 2.5rem;
`;

/* Sección base */
const Wrap = styled(Section)`
  background:#f3f3f2;
  color:#2b2b2b;
  padding: 5rem 0 3.5rem;
`;

/* Contenedor centrado con 80% de ancho */
const Content = styled.div`
  width: 80%;
  margin: 0 auto;
`;

/* Título enorme a la izquierda */
const BigTitle = styled.h1`
  font-size: clamp(2.25rem, 6vw, 4rem); /* ≈64px */
  line-height: 1.05;
  font-weight: 400; /* más delgado */
  letter-spacing: .2px;
  margin: 0;
  max-width: 16ch;

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: clamp(1.8rem, 6vw, 2.6rem);
    line-height: 1.2;
  }
`;

/* Overline con “chevron” */
const Overline = styled.div`
  display: inline-flex;
  align-items: center;
  gap: .6rem;
  font-size: .95rem;
  letter-spacing: .12em;
  font-weight: 700;
  color: #2b2b2b;
  margin: .25rem 0 1rem;

  &:before{
    content:'';
    display:inline-block;
    width:12px; height:12px;
    border-left: 6px solid ${p => p.theme.primaryColor};
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
`;

const Body = styled.div`
  font-size: clamp(1rem, 1.15vw, 1.08rem);
  line-height: 1.65;
  color: #3b3b3b;

  p { margin: 0 0 1rem; }
`;

const RowStyled = styled(Row)`
  --bs-gutter-x: clamp(18px, 3.2vw, 44px);
`;

export default function AboutHistoryStatic(){
  return (
    <Wrap>
      <Content>
        <TopLine />
        <RowStyled className="align-items-start">
          {/* Izquierda: título grande */}
          <Col xs={12} md={6}>
            <BigTitle>Nuestro equipo</BigTitle>
          </Col>

          {/* Derecha: overline y texto */}
          <Col xs={12} md={6}>
            <Overline>¿Qué hacemos?</Overline>
            <Body>
              <p>
                This is a space to share more about the business: who's behind it, what it does
                and what this site has to offer. It’s an opportunity to tell the story behind the business
                or describe a special service or product it offers.
              </p>
              <p>
                You can use this section to share the company's history or highlight a particular feature
                that sets it apart from competitors. Let the writing speak for itself. Keep a consistent tone
                and voice throughout the website to stay true to the brand image and give visitors a taste of
                the company’s values and personality.
              </p>
            </Body>
          </Col>
        </RowStyled>
      </Content>
    </Wrap>
  );
}